import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

function PublicLayout() {
  return (
    <Box component="main" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Outlet />
    </Box>
  );
}

export default PublicLayout;
